export enum GeometryType {
    LINESTRING = 'linestring',
    MULTILINESTRING = 'multilinestring',
    POINT = 'point',
    MULTIPOINT = 'multipoint',
    POLYGON = 'polygon',
    MULTIPOLYGON = 'multipolygon',
    GEOMETRY = 'geometry',
}
